import en from './en';
import nl from './nl';
import de from './de';

export const defaultLocale = 'nl';

export const languages = {
  en, nl, de
};
